import { Meta } from "../../meta/meta";
import { About } from "./components/about/about";
import { Services } from "./components/services/services";
import { News } from "./components/news/news";
import { UsefulLinks } from "./components/usefulLinks/usefulLinks";

const Home = () => {
  return (
    <>
      <Meta title="" description="webname" />
      <main>
        <About />
        <Services />
        <News />
        <UsefulLinks />
      </main>
    </>
  );
};

export default Home;
